import api from 'api/api'
import { toast } from 'react-toastify'

import { downloadBase64File } from 'utils'
import { API_URL, FILE_TYPE } from 'constants/index'

export const GET_INVENTORY_PRODUCTS = '[INVENTORY PRODUCTS] GET INVENTORY PRODUCTS'

export const CRUD_INVENTORY_PRODUCT = '[INVENTORY PRODUCTS] CRUD INVENTORY PRODUCT'

export const DOWNLOADING_INVENTORY_PRODUCTS = "[PRODUCTS] DOWNLOADING INVENTORY PRODUCTS"

export function getInventoryProducts({ page = 1, pageSize = 10, storeId = 0, status = '', search = '' }) {
  const request = api.get(`/inventario-producto/productos`, {
    params: {
      page,
      por_pagina: pageSize,
      almacen_id: storeId,
      estado: status,
      busqueda: search
    }
  })
  return dispatch => {
    dispatch({ type: GET_INVENTORY_PRODUCTS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_INVENTORY_PRODUCTS, payload: { loading: false, ...response.data } })
    }).catch((error) => {
      dispatch({ type: GET_INVENTORY_PRODUCTS, payload: { loading: false } })
      console.log(error);
    })
  }
}

export function saveInventoryProduct(form) {
  const request = api.post(
    `/inventario-producto/guardar`,
    form
  )
  return (dispatch) => {
    dispatch({ type: CRUD_INVENTORY_PRODUCT, payload: { loading: true } })
    request
      .then((response) => {
        if (parseInt(response.data.status) === 200) {
          dispatch({
            type: CRUD_INVENTORY_PRODUCT,
            payload: { loading: false, crud: true },
          })
          toast.success(response.data.message)
        } else {
          dispatch({
            type: CRUD_INVENTORY_PRODUCT,
            payload: { loading: false, crud: false },
          })
          toast.error(response.data.message)
        }

        dispatch({
          type: CRUD_INVENTORY_PRODUCT,
          payload: { loading: false, crud: false },
        })
      })
      .catch((error) => {
        dispatch({
          type: CRUD_INVENTORY_PRODUCT,
          payload: { loading: false, crud: false },
        })
        toast.error('Error inesperado. No se pudo procesar la solicitud')
        console.log(error)
      })
  }
}

export function synchronizeInventoryProduct(form) {
  const request = api.post(
    `/inventario-producto/regularizar`,
    form
  )
  return (dispatch) => {
    dispatch({ type: CRUD_INVENTORY_PRODUCT, payload: { loading: true } })
    request
      .then((response) => {
        if (parseInt(response.data.status) === 200) {
          dispatch({
            type: CRUD_INVENTORY_PRODUCT,
            payload: { loading: false, crud: true },
          })
          toast.success(response.data.message)
        } else {
          dispatch({
            type: CRUD_INVENTORY_PRODUCT,
            payload: { loading: false, crud: false },
          })
          toast.error(response.data.message)
        }

        dispatch({
          type: CRUD_INVENTORY_PRODUCT,
          payload: { loading: false, crud: false },
        })
      })
      .catch((error) => {
        dispatch({
          type: CRUD_INVENTORY_PRODUCT,
          payload: { loading: false, crud: false },
        })
        toast.error('Error inesperado. No se pudo procesar la solicitud')
        console.log(error)
      })
  }
}

export function synchronizeAllInventoryProducts(almacenId) {
  const request = api.post(
    `/inventario-producto/regularizar-todo`,
    { almacen_id: almacenId }
  )
  return (dispatch) => {
    dispatch({ type: CRUD_INVENTORY_PRODUCT, payload: { loading: true } })
    request
      .then((response) => {
        if (parseInt(response.data.status) === 200) {
          dispatch({
            type: CRUD_INVENTORY_PRODUCT,
            payload: { loading: false, crud: true },
          })
          toast.success(response.data.message)
        } else {
          dispatch({
            type: CRUD_INVENTORY_PRODUCT,
            payload: { loading: false, crud: false },
          })
          toast.error(response.data.message)
        }

        dispatch({
          type: CRUD_INVENTORY_PRODUCT,
          payload: { loading: false, crud: false },
        })
      })
      .catch((error) => {
        dispatch({
          type: CRUD_INVENTORY_PRODUCT,
          payload: { loading: false, crud: false },
        })
        toast.error('Error inesperado. No se pudo procesar la solicitud')
        console.log(error)
      })
  }
}

export function getPendingSyncCount(storeId) {
  const request = api.get(`/inventario-producto/conteo-pendiente`, {
    params: { almacen_id: storeId }
  })
  
  return () => {
    return request.then(response => {
      return response.data.count
    }).catch(error => {
      console.error(error)
      return 0
    })
  }
}

export function downloadInventoryProductsExcel({ storeId = 0, status = '', search = '' }) {
  const request = api.get(`/inventario-producto/excel-productos-inventario`, {
    params: {
      almacen_id: storeId,
      estado: status,
      busqueda: search
    }
  })
  return (dispatch) => {
    dispatch({ type: DOWNLOADING_INVENTORY_PRODUCTS, payload: true })
    request.then((response) => {
      downloadBase64File({
        filename: response.data.nombre,
        fileType: FILE_TYPE.EXCEL,
        file: response.data.archivo
      })
      toast.success('Se descargó el EXCEL.')
      dispatch({ type: DOWNLOADING_INVENTORY_PRODUCTS, payload: false })
      return
    }).catch((error) => {
      dispatch({ type: DOWNLOADING_INVENTORY_PRODUCTS, payload: false })
      toast.error('Algo salió mal. No se pudo descargar el EXCEL.')
      console.error(error)
    })
  }
}